import {useTranslation} from "react-i18next";
import SymptomsTable from "../symptoms/SymptomsTable";
import {Consts} from "../pages/consts";
import {getPatientName} from "../pages/utils";

const PatientSymptoms = ({
                           showDialog,
                           onCloseDialog,
                           patient,
                           isStudyDirector,
                         }) => {
  const {t: t} = useTranslation();

  return (
    <div
      className="w3-modal"
      style={ {display: showDialog ? Consts.BLOCK : Consts.NONE} }
    >
      <div className="w3-modal-content w3-card-4 w3-animate-zoom w3-theme-l3 dialog-medium">
        <SymptomsTable
          selectedPatient={ patient }
          hcpView={ true }
        >
          <h2>
            { t("symptoms_of_patient") }{ " " }
            { getPatientName(patient, isStudyDirector) }
          </h2>
        </SymptomsTable>
        <footer className="w3-container w3-padding-small">
          <p className="w3-right">
            <button
              className="w3-btn w3-round-xlarge w3-theme-d5 w3-margin-left"
              onClick={ onCloseDialog }
            >
              { t("close") }
            </button>
          </p>
        </footer>
      </div>
    </div>
  );
};

export default PatientSymptoms;
